/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'

export interface ReservationContextInterface {
  data: any;
  isLoading: boolean;
  timeOut: boolean;
  error?: string,
}

const ReservationContext = React.createContext<ReservationContextInterface | null>(null)

export default ReservationContext
